import {PageContent} from "./PageContent";

export const Impressum = () => {
    return (
        <PageContent slug="impressum" fallbackTitle="Impressum" portableTextWrapClassName="impressum-content impressum-centered">
            <div className="impressum-content" >
                <div>
                    <h2>Angaben gemäß § 5 TMG</h2>
                    <p>Beate Hoffmann<br />
                        Königsgarten 9<br />
                        67146 Deidesheim</p>

                    <h2>Kontakt</h2>
                    <p>E-Mail: info@biodanzaschule-freiburg.de</p>
                    <p>Quelle: <a href="https://www.e-recht24.de">https://www.e-recht24.de</a></p>
                </div>
            </div>
        </PageContent>
    )
}